import { z } from "zod";

export const SelectionSearchRequestSchema = z.object({
  country: z.string().trim().min(1).max(80),
  platform: z.string().trim().min(1).max(80),
  category: z.string().trim().min(1).max(100),
});
export type SelectionSearchRequest = z.infer<typeof SelectionSearchRequestSchema>;
export const SelectionSearchResponseSchema = z.object({
  terms: z.array(z.object({
    term: z.string().trim().min(1).max(100),
    reason: z.string().trim().min(1).max(200),
  })).min(1).max(8),
});
export type SelectionSearchResponse = z.infer<typeof SelectionSearchResponseSchema>;

export const SupplierQuestionsRequestSchema = z.object({
  productTitle: z.string().trim().min(1).max(500),
  sourceFacts: z.array(z.object({ label: z.string().max(100), value: z.string().max(500) })).max(16),
  country: z.string().trim().min(1).max(80),
  platform: z.string().trim().min(1).max(80),
});
export type SupplierQuestionsRequest = z.infer<typeof SupplierQuestionsRequestSchema>;
export const SupplierQuestionsResponseSchema = z.object({
  questions: z.array(z.object({
    question: z.string().trim().min(1).max(240),
    reason: z.string().trim().min(1).max(240),
  })).min(1).max(12),
});
export type SupplierQuestionsResponse = z.infer<typeof SupplierQuestionsResponseSchema>;
